import React from 'react';
import PropTypes from 'prop-types';
import { ImageBackground } from 'react-native-web';
import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { APP } from '../../../config';

import Analytics from '../../../modules/analytics';
import InfoSwiper from '../../ui/InfoSwiper';
import Icon from '../../ui/Icon/Icon';
import Button from '../../ui/Button';
import {
  BodyText,
  HeaderText,
} from '../../ui';
import CIRCLE_CHECK from '../../../../images/icons/checked-punch.svg';
import './NCDEducationModal.module.scss';

const NCD_EXPOSURE = require('../../../../images/newclientdelivery_exposure_bg.png');

const NCDEducationModal = ({ onClose }) => {
  const learnMoreLink = 'https://styleseat.freshdesk.com/support/solutions/articles/69000469741-grow-your-business-with-styleseat-marketing-';
  const textUsLink = 'https://styleseat.freshdesk.com/support/tickets/new';
  const linkTarget = APP ? '_system' : '_blank';

  const handleLearnMoreClick = () => {
    window.open(learnMoreLink, linkTarget);
  };

  const handleContactUsClick = () => {
    window.open(textUsLink, linkTarget);
  };

  return (
    <InfoSwiper
      className="ncd-education-swiper"
      onSlideViewed={pageNo => Analytics.track('pro_ncd_educational_swiper_viewed', { page_number: pageNo + 1 })}
      onDismissed={
        pageNo => {
          Analytics.track('pro_ncd_educational_swiper_dismissed', { page_number: pageNo + 1 });
          onClose();
          // eslint-disable-next-line react/jsx-indent
        }
      }
    >
      {/* ------------- Slide 1 ------------- */}
      <Box
        paddingLeft={36}
        paddingRight={36}
        paddingBottom={24}
        style={{ height: '100%' }}
      >
        <Box
          styleName="image-container"
        >
          <ImageBackground
            source={NCD_EXPOSURE}
            styleName="ncd-exposure-image"
          />
        </Box>
        <Box>
          <BodyText
            theme="provider"
            appearance="larger"
            weight="bold"
            color={colors.blackInBlack}
            textAlign="center"
          >
            <BodyText
              theme="provider"
              appearance="larger"
              weight="bold"
              color={colors.punch}
              style={{ marginRight: '8px' }}
            >
              New!
            </BodyText>
            We&apos;re helping you get&nbsp;exposure
          </BodyText>
          <Box
            paddingTop={16}
          >
            <BodyText
              color={colors.blackInBlack}
              theme="provider"
              weight="normal"
              appearance="large"
              textAlign="center"
            >
              We’re running ads and promoting your profile across search engines and
              social media to get you discovered by new clients.
            </BodyText>
          </Box>
        </Box>
        <Box
          styleName="button-container"
        >
          <Button
            text="Learn More"
            size="large"
            onClick={handleLearnMoreClick}
            style={{ width: '225px' }}
            clickTracking={{
              name: 'pro_ncd_educational_swiper_slide_1_learn_more_clicked',
            }}
          />
          <Box
            padding={8}
            paddingTop={16}
          >
            <BodyText
              textAlign="center"
              theme="provider"
              appearance="smaller"
              weight="normal"
            >
              Want us to stop sending new clients?
              <Box
                paddingLeft={4}
                paddingRight={4}
                style={{
                  width: '68px',
                  height: '19px',
                  marginRight: '8px',
                }}
              >
                <Button
                  text="Contact us"
                  appearance="link"
                  onClick={handleContactUsClick}
                  size="small"
                  clickTracking={{
                    name: 'pro_ncd_educational_swiper_slide_1_text_us_link_clicked',
                  }}
                  style={{
                    width: '68px',
                    height: '19px',
                    marginRight: '8px',
                  }}
                />
              </Box>
              and we&apos;ll remove you from the&nbsp;program.
            </BodyText>
          </Box>
        </Box>
      </Box>

      {/* ------------- Slide 2 ------------- */}
      <Box
        paddingTop={48}
        paddingLeft={36}
        paddingRight={36}
        paddingBottom={24}
        style={{ height: '100%' }}
      >
        <HeaderText
          level={1}
          theme="provider"
          color={colors.blackInBlack}
        >
          New StyleSeat clients are worth $550 a year on&nbsp;average
        </HeaderText>

        <Inline>
          <Box
            paddingRight={12}
          >
            <Icon
              uri={CIRCLE_CHECK}
              size={24}
            />
          </Box>
          <Box>
            <BodyText>
              Great Investment
            </BodyText>
            <BodyText
              style={{ width: '250px' }}
            >
              We keep 35% of the first appointment only and invest it back into marketing for you.
              Tips are all yours!
            </BodyText>
          </Box>
        </Inline>
        <Inline>
          <Box
            paddingTop={24}
            paddingRight={12}
          >
            <Icon
              uri={CIRCLE_CHECK}
              size={24}
            />
          </Box>
          <Box
            paddingTop={24}
          >
            <BodyText>
              Easy Checkout
            </BodyText>
            <BodyText
              style={{ width: '250px' }}
            >
              These appointments are charged automatically through the app for a touchless payments
              experience clients love.
            </BodyText>
          </Box>
        </Inline>

        <Box
          styleName="button-container"
        >
          <Button
            text="Learn More"
            size="large"
            onClick={handleLearnMoreClick}
            style={{ width: '225px' }}
            clickTracking={{
              name: 'pro_ncd_educational_swiper_slide_2_learn_more_clicked',
            }}
          />
          <Box
            padding={8}
            paddingTop={16}
          >
            <BodyText
              textAlign="center"
              theme="provider"
              appearance="smaller"
              weight="normal"
            >
              Want us to stop sending new clients?
              <Box
                paddingLeft={4}
                paddingRight={4}
                style={{
                  width: '68px',
                  height: '19px',
                  marginRight: '8px',
                }}
              >
                <Button
                  text="Contact us"
                  appearance="link"
                  onClick={handleContactUsClick}
                  size="small"
                  clickTracking={{
                    name: 'pro_ncd_educational_swiper_slide_2_text_us_link_clicked',
                  }}
                  style={{
                    width: '68px',
                    height: '19px',
                    marginRight: '8px',
                  }}
                />
              </Box>
              and we&apos;ll remove you from the&nbsp;program.
            </BodyText>
          </Box>
        </Box>

      </Box>
    </InfoSwiper>
  );
};

NCDEducationModal.propTypes = {
  onClose: PropTypes.func,
};

NCDEducationModal.defaultProps = {
  onClose: () => { },
};

export default NCDEducationModal;
